import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import '../../components/Website/Website.css';
import './css/Form.css';
import { getAdminUser, addAdminUser, updateAdminUser } from '../../services/requests';
import Layout from '../../components/Website/Layout';

const AdminUserForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [user, setUser] = useState({
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        confirmPassword: ''
    });
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (id) {
            getAdminUser(id)
                .then(response => {
                    console.log('getAdminUser response:', response); // <-- Add this line
                    setUser({
                        first_name: response.user.first_name,
                        last_name: response.user.last_name,
                        email: response.user.email
                    });
                })
                .catch(error => {
                    console.error('getAdminUser error:', error); // <-- Add this line
                    setErrorMessage('Failed to fetch admin user data');
                });
        }
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUser(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage(''); // Clear previous errors

        if (user.password || user.confirmPassword) {
            if (user.password !== user.confirmPassword) {
                setErrorMessage('Passwords do not match');
                return;
            }
        }

        try {
            let response;
            if (id) {
                const payload = { ...user };
                if (!user.password) delete payload.password;
                delete payload.confirmPassword;
                response = await updateAdminUser(id, payload);
                console.log('updateAdminUser response:', response); // <-- Add this line
            } else {
                const payload = { ...user };
                delete payload.confirmPassword;
                response = await addAdminUser(payload);
                console.log('addAdminUser response:', response); // <-- Optional: log add as well
            }

            if (response && response.errors) {
                setErrorMessage(
                    typeof response.errors === 'string'
                        ? response.errors
                        : Object.values(response.errors).flat().join(' ')
                );
            } else if (response && response.message && response.status === 422) {
                setErrorMessage(response.message);
            } else if (response && response.error) {
                setErrorMessage(response.error);
            } else {
                navigate('/admin/admin-users?updated=true');
            }
        } catch (error) {
            setErrorMessage('An unexpected error occurred.');
        }
    };

    const handleCancelClick = () => {
        navigate('/admin/admin-users')
    }

    return (
    <Layout>        
        <div className="container">        
            <h3 className="website__header">
                {id ? 'Edit Admin User' : 'Add Admin User'}
            </h3>
            <p className="website__header-subtitle">
                {id
                    ? 'Update the details of the admin user below.'
                    : 'Enter the details for the new admin user below.'}
            </p>

            {errorMessage ? 
                <div className="alert alert-danger" role="alert">
                    {errorMessage}
                </div>
            : ''}

            <div className="row user-form__box">
                <div className="col-12 col-md-8 col-lg-12">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <div className="form-group">
                                    <label className="user-form__label">First Name</label>
                                    <input
                                        className="form-control user-form__input"
                                        type="text"
                                        name="first_name"
                                        value={user.first_name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="form-group">
                                    <label className="user-form__label">Last Name</label>
                                    <input
                                        className="form-control user-form__input"
                                        type="text"
                                        name="last_name"
                                        value={user.last_name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="user-form__label">Email</label>
                            <input
                                className="form-control user-form__input"
                                type="email"
                                name="email"
                                value={user.email}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label className="user-form__label">
                                Password{id ? " (leave blank to keep current)" : ""}
                            </label>
                            <input
                                className="form-control user-form__input"
                                type="password"
                                name="password"
                                value={user.password}
                                onChange={handleChange}
                                autoComplete="new-password"
                                {...(!id && { required: true })}
                            />
                        </div>
                        <div className="form-group">
                            <label className="user-form__label">
                                Confirm Password{id ? " (leave blank to keep current)" : ""}
                            </label>
                            <input
                                className="form-control user-form__input"
                                type="password"
                                name="confirmPassword"
                                value={user.confirmPassword}
                                onChange={handleChange}
                                autoComplete="new-password"
                                {...(!id && { required: true })}
                            />
                        </div>
                        <div className="d-flex justify-content-end">
                            <button type="button" onClick={handleCancelClick} className="btn btn-secondary user-form__cancel-button me-2">Cancel</button>
                            <button type="submit" className="btn btn-primary user-form__save-button">Save</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </Layout>
    );
};

export default AdminUserForm;
